// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import "firebase/firestore";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCMIpkcNgTfJ7xwCM7dENCFlJgzlgy5-8A",
  authDomain: "mamabless-9564a.firebaseapp.com",
  projectId: "mamabless-9564a",
  storageBucket: "mamabless-9564a.appspot.com",
  messagingSenderId: "882571932061",
  appId: "1:882571932061:web:d2d0928d0bd0a1f11c3f74",
  measurementId: "G-EV0QSSD5RN"
};

firebase.initializeApp(firebaseConfig)

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app)
export const authentication = getAuth(app);
const analytics = getAnalytics(app);

export default app